import React, { ReactNode } from 'react';
import { defaultTheme } from './../../config/theming';
import styled from '@emotion/styled';

const Text = styled.a`
  color: ${defaultTheme.colors.primary};
  font-size: 1rem;
  padding-top: 15px;
  font-weight: 600;
  cursor: pointer;
  &:hover {
    border-bottom: 2px solid ${defaultTheme.colors.lighterPrimary};
  }
  &:active {
    color: ${defaultTheme.colors.lighterPrimary};
  }
`;

interface Props {
  clickFn: () => void;
  children: ReactNode;
}

export const TextButton = (props: Props) => {
  return <Text onClick={props.clickFn}>{props.children}</Text>;
};

export default TextButton;
